import type { ReactElement } from 'react';
import { CheckField, DatePickerField, DateRangePickerField, TextField } from '@ff-it/form';
import { PayerVATCategoryField, PaymentDateField } from 'components';
import { CompanyField } from 'modules/core/company/components';
import { IncomeClientPONumberField } from 'routes/Agency/Invoices/Income/IncomeClientPONumberField';

type InvoiceFieldsProps = {
  variant?: 'campaign' | 'bonus';
};

function InvoiceOptions({ showPONumber = false }: { showPONumber?: boolean }): ReactElement {
  return (
    <div className="d-flex align-items-center" role="group" aria-label="Invoice options">
      {showPONumber && (
        <CheckField name="hide_client_po_number" fieldLabel="Hide PO number" variant="checkbox" inline />
      )}
      <CheckField name="hide_issuer" fieldLabel="Hide issuer" variant="checkbox" inline />
    </div>
  );
}

export function InvoiceFields({ variant = 'campaign' }: InvoiceFieldsProps): ReactElement {
  const isCampaign = variant === 'campaign';

  return (
    <>
      <div className="form-row">
        <CompanyField name="payer" label="Payer" required className="col-md-2" size="sm" includeBranches={true} />
        <DatePickerField name="checkout_date" label="Invoice date" className="col-md-1" size="sm" required />
        <PaymentDateField name="payment_date" label="Payment date" className="col-md-1" size="sm" required />
        <PayerVATCategoryField label="VAT category" className="col-md-2" size="sm" required />
        {isCampaign ? (
          <DateRangePickerField
            fromName="date_from"
            toName="date_to"
            className="col-md-2"
            size="sm"
            label="Service period"
            readOnly
          />
        ) : (
          <div className="form-group col-auto pt-4">
            <InvoiceOptions />
          </div>
        )}
      </div>
      {isCampaign && (
        <div className="form-row">
          <TextField
            name="campaign_title"
            placeholder="Campaign title"
            className="col-md-2"
            size="sm"
            help="Leave empty to use linked"
          />
          <IncomeClientPONumberField size="sm" placeholder="PO number" />
          <TextField name="comment" placeholder="Comment" className="col-md-2" size="sm" multiline />
          <div className="form-group col-auto ml-3">
            <InvoiceOptions showPONumber />
          </div>
        </div>
      )}
    </>
  );
}
